import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Fashion', icon: '👕', value: 'Fashion' },
  { name: 'Tech', icon: '💻', value: 'Tech' },
  { name: 'Food', icon: '🍔', value: 'Food', link: "/restuarant" },
  { name: 'Services', icon: '🔨', value: 'service', link: "/service" },
  // { name: 'Event', icon: '🔨', value: 'Event', link: "/Event" },
  { name: 'All', icon: '🛍️', value: 'All' },
];

const CategoryCards = ({ onCategoryClick }) => {
  return (
    <div className="bg-transparent flex flex-wrap justify-center gap-6 py-6">
      {categories.map((cat, i) =>
        cat.link ? (
          <Link
            to={cat.link}
            key={i}
            onClick={() => onCategoryClick(cat.value)}
            className="cursor-pointer bg-white/10 hover:bg-green-500 text-white px-6 py-4 rounded-xl text-center w-[120px] transition"
          >
            <div className="text-3xl">{cat.icon}</div>
            <p className="mt-2 font-semibold">{cat.name}</p>
          </Link>
        ) : (
          <div
            key={i}
            onClick={() => onCategoryClick(cat.value)}
            className="cursor-pointer bg-white/10 hover:bg-green-500 text-white px-6 py-4 rounded-xl text-center w-[120px] transition"
          >
            <div className="text-3xl">{cat.icon}</div>
            <p className="mt-2 font-semibold">{cat.name}</p>
          </div>
        )
      )}
    </div>
  );
};

export default CategoryCards;
